import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { PARTICIPANTS_QUERIES } from "~/shared/api/participants/participants.queries";
import { notFound } from "~/shared/util/notFound";
import { getSkip } from "~/shared/util/pagination.helpers";
import {
  MAX_RESULTS_PER_PAGE,
  SAVED_ROLES_SEARCH_PARAM_KEY,
  SavedRolesSearchParamSchema,
} from "~/team/components/ParticipantSavedRolesDataTable/ParticipantSavedRolesDataTable";

export function participantSavedRolesViewLoader(args: LoaderFunctionArgs, queryClient: QueryClient) {
  const { participantId } = args.params;
  const searchParams = new URL(args.request.url).searchParams;
  const pageParam = searchParams.get(SAVED_ROLES_SEARCH_PARAM_KEY.PAGE);
  const { page } = SavedRolesSearchParamSchema.parse({ page: pageParam });

  if (!participantId) {
    return notFound();
  }

  queryClient.prefetchQuery(
    PARTICIPANTS_QUERIES.savedRolesList(participantId, {
      params: {
        limit: MAX_RESULTS_PER_PAGE,
        skip: getSkip(page, MAX_RESULTS_PER_PAGE),
      },
    }),
  );

  return null;
}
